// @flow
import React from 'react';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';

type FooterWebsiteProps = {
  description: string,
  href: string,
  iconAlt: string,
  iconName: IconName,
  iconWidth: string,
  isVisible?: boolean,
};

export function FooterWebsite({
  description,
  href,
  iconAlt,
  iconName,
  iconWidth,
  isVisible,
}: FooterWebsiteProps) {
  if (!isVisible) {
    return null;
  }
  return (
    <li className="align-top inline-block mb-9 px-3 w-1/2 lg:w-full">
      <DynamicLink
        className="reset-anchor block focus:underline hover:underline"
        target="_blank"
        url={href}
      >
        <p
          aria-level="2"
          className="reset-paragraph mb-1"
          role="heading"
          style={{ minHeight: '2.5rem' }}
        >
          <Icon alt={iconAlt} name={iconName} isNotSquare width={iconWidth} />
          <span className="a11y">{iconAlt}</span>
        </p>
        <p className="reset-paragraph text-base">{description}</p>
      </DynamicLink>
    </li>
  );
}
